import { InputHTMLAttributes, LabelHTMLAttributes, useState } from "react";
import IconButton from "../IconButton";
import "./index.scss";
import { IconButtonProps } from "../IconButton";
import { getCurrentBrowser } from "../../libs/currentBrowser";

export const InputV3 = ({
  inputProps,
  iconButtonProps,
  labelProps,
  errorStatus,
  errorMessage,
  classNameBoxInput = "",
}: {
  inputProps: InputHTMLAttributes<HTMLInputElement>;
  iconButtonProps?: IconButtonProps;
  labelProps: LabelHTMLAttributes<HTMLLabelElement>;
  errorStatus?: boolean;
  errorMessage?: string;
  classNameBoxInput?: string;
}) => {
  const [click, setClick] = useState(false);

  const currentBrowser = getCurrentBrowser();

  const notIsEdge = currentBrowser !== "Edge" ? true : false;

  return (
    <>
      <label
        {...labelProps}
        className={`${labelProps?.className} ml-4 text-textPrimary font-familyPoppins text-1.4rem label-input-v3 ${
          errorStatus ? "text-red-700" : ""
        }`}
      />
      <div
        onClick={() => setClick(true)}
        onBlur={() => setClick(false)}
        onBlurCapture={() => setClick(false)}
        className={`flex flex-row h-16 ml-1 rounded-lg border-2 border-gray-300 box-input-v3 ${classNameBoxInput} ${
          !errorStatus && click ? "border-blue-600 ring-blue-300" : ""
        } ${errorStatus ? "border-red-500" : ""}`}
      >
        <input
          {...inputProps}
          className={`${inputProps?.className} ml-2 text-1.4rem text-textPrimary font-familyPoppins ${errorStatus ? "text-red-800" : ""}`}
        />
        {iconButtonProps?.icon && notIsEdge ? (
          <IconButton
            {...iconButtonProps}
            className={`${iconButtonProps?.className} mr-0 text-textPrimary icon-input-v3 ${errorStatus ? "text-red-800" : ""}`}
          />
        ) : (
          ""
        )}
      </div>
      {errorStatus && <span className={`text-red-500 ml-5 font-bold text-xl error-input-v3`}>{errorMessage}</span>}
    </>
  );
};
